<div class="vimeo {vimeoClass}">

    <iframe title="Vimeo Video {videoId}" class="vimeo__player" allowFullScreen frameborder="0" height={height} mozallowfullscreen src={vimeoUrl} webkitAllowFullScreen width={width} />

</div>

<style>

    .vimeo {
        overflow: hidden;
        position: relative;
    }

    .vimeo.vimeo--format-16-by-9 {
        height: 0;
        padding-bottom: calc(100% / 16 * 9);
    }

    .vimeo__player {
        display: block;
        height: 100%;
        width: 100%;
    }

    .vimeo.vimeo--format-16-by-9 .vimeo__player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

</style>

<script>
    export default {
        computed: {
            vimeoUrl: ({ videoId }) => {
                return `https://player.vimeo.com/video/${videoId}`
            },
            vimeoClass: ({ format }) => {
                let classes = []

                if (format) classes.push(`vimeo--format-${format}`)

                return classes.filter(Boolean).join(' ')
            }
        },
        data() {
            return {
                videoId: '',
                width: 1920,
                height: 1080,
                format: '16-by-9'
            }
        }
    }
</script>